/* SHARED — the dictionaries and the small pieces every tab of the card of the point draws with */

/* The states of a booking — the colours repeat the ones the applications use */
export const BOOKING_STATUSES = [
    { status: 0, text: "Ожидание", color: "green" },
    { status: 1, text: "Принята", color: "purple" },
    { status: 2, text: "Завершена", color: "" },
    { status: 3, text: "Отменена", color: "red" },
    { status: 4, text: "Не пришёл", color: "red" }
]

/* Where the client came from */
export const CHANNELS = {
    app: "Приложение",
    web: "Сайт",
    "2gis": "2ГИС",
    owner: "Заведение",
    qr: "QR код",
    share: "Ссылка"
}

/* The roles of the team */
export const ROLES = {
    owner: "Владелец",
    admin: "Администратор",
    specialist: "Специалист"
}

/* The states of a subscription */
export const SUBSCRIPTION_STATUSES = {
    pending: { text: "Ожидает оплаты", color: "orange" },
    active: { text: "Активна", color: "green" },
    past_due: { text: "Не оплачена", color: "red" },
    cancelled: { text: "Отменена", color: "grey" },
    expired: { text: "Истекла", color: "red" }
}

/* The days of the week in the order the schedule is read in */
export const DAYS = [
    { day: "monday", text: "Пн" },
    { day: "tuesday", text: "Вт" },
    { day: "wednesday", text: "Ср" },
    { day: "thursday", text: "Чт" },
    { day: "friday", text: "Пт" },
    { day: "saturday", text: "Сб" },
    { day: "sunday", text: "Вс" }
]

/* The links of the point — every social network it left an address in */
export const SOCIALS = [
    { key: "instagram", text: "Instagram" },
    { key: "whatsapp", text: "WhatsApp" },
    { key: "telegram", text: "Telegram" },
    { key: "tiktok", text: "TikTok" },
    { key: "threads", text: "Threads" },
    { key: "facebook", text: "Facebook" },
    { key: "youtube", text: "YouTube" },
    { key: "gis", text: "2ГИС" }
]


/* The icon of a point — it stands in place of the photo the point has not uploaded yet */
export const organizationIcon = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none">
            <path d="M4.4 9.6V19a1.1 1.1 0 0 0 1.1 1.1h13a1.1 1.1 0 0 0 1.1-1.1V9.6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.9 9.6h18.2l-1.36-4.05a1.6 1.6 0 0 0-1.52-1.1H5.78a1.6 1.6 0 0 0-1.52 1.1L2.9 9.6Z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
            <path d="M9.9 20.1v-3.9a2.1 2.1 0 0 1 4.2 0v3.9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}


/* A sum which came out of the base as a text is still a number */
export const number = value => {

    const parsed = parseFloat(value)

    if (isNaN(parsed)) {
        return 0
    }

    return parsed
}


/* One line of the card — the name of the field and its value */
export const line = (text, value, link = null) => {

    if (value === null || value === undefined || `${value}`.length === 0) {
        return null
    }

    return (
        <div className="organization-details-line" key={text}>
            <div className="organization-details-line-text">{text}</div>
            {link
                ? <a className="organization-details-line-value link" href={link} target="_blank" rel="noreferrer">{value}</a>
                : <div className="organization-details-line-value">{value}</div>
            }
        </div>
    )
}


/* One number of the point */
export const metric = (text, value, accent = "") => {
    return (
        <div className={`organization-details-metric ${accent}`} key={text}>
            <div className="organization-details-metric-value">{value}</div>
            <div className="organization-details-metric-text">{text}</div>
        </div>
    )
}
